import { z } from 'zod';
// TODO enforce category matches DB enum
export const AlertCategory = {
    Home: 'Home',
    Product: 'Product',
    Settings: 'Settings',
};
export const AlertSeverity = {
    Info: 'Info',
    Warning: 'Warning',
};
export const storeAlert = z.object({
    id: z.number(),
    severity: z.enum(AlertSeverity),
    category: z.enum(AlertCategory),
    // potentially make this an enum
    subject: z.string(),
    message: z.string(),
    url: z.string().nullable(),
    createdOn: z.string(),
    readOn: z.string().nullable(),
});
export const storeAlertUpdate = storeAlert.pick({
    readOn: true,
});
export const storeAlertCreate = storeAlert.omit({
    id: true,
    createdOn: true,
    readOn: true,
});
//# sourceMappingURL=storeAlert.js.map